// @flow
import { get } from 'lodash';

import {
  CLEAR_ADDITIONAL_TRANSPORTS,
  CREATE_ADDITIONAL_TRANSPORTS_FILTERS,
  FETCH_ADDITIONAL_TRANSPORTS,
  TOGGLE_FILTER,
  DISABLE_FILTERS,
  UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY,
} from 'Store/booking/additional-transports/additionalTransports.action';
import { getFiltersWithMatchedOccurrences, toggleFilter } from 'Store/filters/filtersHelper';
import { createFilters, unselectCategory, unselectFilters } from './filterUtils';

type State = ?Array<Filter>;

const initialState: State = null;

export default function filtersReducer(state: State = initialState, action: ?Action<*>): State {
  const additionalTransports = get(action, 'payload.additionalTransports') || [];
  const getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(additionalTransports);

  switch (get(action, 'type')) {
    case CLEAR_ADDITIONAL_TRANSPORTS:
    case FETCH_ADDITIONAL_TRANSPORTS:
      return initialState;

    case CREATE_ADDITIONAL_TRANSPORTS_FILTERS:
      const i18n = get(action, 'payload.i18n') || {};
      const timeRanges = get(i18n, 'filters.departureArrival.timeRanges') || [];
      const filters = createFilters(additionalTransports, timeRanges, i18n);
      return getFiltersWithOccurrences(filters);

    case TOGGLE_FILTER:
      const filter = get(action, 'payload.filter');
      return toggleFilter(additionalTransports)(state || [], filter);

    case UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY:
      const category = get(action, 'payload.category', '');
      const updatedFilters = unselectCategory(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    case DISABLE_FILTERS:
      const filtersToDisable = get(action, 'payload.filters', []);
      return getFiltersWithOccurrences(unselectFilters(state || [], filtersToDisable));

    default:
      return state;
  }
}
